import {
  CButton,
  CCol,
  CForm,
  CLabel,
  // CModal,
  // CModalBody,
  // CModalFooter,
  // CModalTitle,
  CRow,
  // CModal,
  // CModalBody,
  // CModalFooter,
  // CModalHeader,
  // CModalTitle,
  CSpinner,
} from "@coreui/react";
import { styled } from "@mui/system";
import Modal from "@mui/material/Modal";
import { Paper } from "@mui/material";

const ConfirmationPopup = ({
  showModal,
  hideModal,
  confirmModal,
  id,
  ModalBody,
  index = -1,
  ButtonLoader = false,
  ModalTitle = "",
}) => {
  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  // if (ModalTitle === "") {
  //   ModalTitle = "Confirmation";
  // }

  const handleClose = (event, reason) => {
    console.log("reason : ", reason);
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      hideModal();
    }
  };

  // const handleClose = (e, reason) => {
  //   e.preventDefault();
  //   console.log("event : ", e);
  //   console.log("reason : ", reason);
  //   if (e !== undefined) {
  //     console.log("event 2: ", e.target.innerHTML);
  //   }
  //   if (e !== undefined && e.target.innerHTML === "No") {
  //     hideModal();
  //   }
  // };
  // const stylePaper = {
  //   position: "absolute",
  //   top: "25%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 400,
  //   borderRadius: "4px",
  //   fontSize: "1rem",
  //   padding: "1.5rem 1rem 0.75rem 1rem",
  // };
  const rowFooterStyle =
    ModalTitle !== ""
      ? {
          borderTop: "0.5px solid #CCC",
          margin: "2rem -1rem 0rem -1rem",
        }
      : {};
  const rowFooterClassName = ModalTitle === "" ? "mt-3 mb-2" : "";

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "1rem 1.5rem 1rem",
  };
  return (
    <div>
      {/* <Modal
        open={showModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropComponent={Backdrop}
      >
        <Paper style={style} elevation={3}>
          <CForm className="needs-validation">
            <CRow>
              <CCol>
                <CLabel>{ModalBody}</CLabel>
              </CCol>
            </CRow>
            <CRow
              style={{
                marginLeft: "7rem",
              }}
            >
              <CCol xl={3}></CCol>
              <CCol xl={3}></CCol>
              <CCol xl={3}>
                <CButton
                  className="mt-3"
                  color="success"
                  onClick={() => {
                    index > -1 ? confirmModal(id, index) : confirmModal(id);
                  }}
                >
                  {" "}
                  {ButtonLoader && (
                    <>
                      <CSpinner as="span" size="sm" aria-hidden="true" />
                      &nbsp;
                    </>
                  )}
                  Yes
                </CButton>
              </CCol>
              <CCol xl={3}>
                <CButton
                  className="mt-3 btn btn-dark"
                  color="success"
                  type="button"
                  onClick={!ButtonLoader && handleClose}
                  disabled={ButtonLoader}
                >
                  No
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </Paper>
      </Modal> */}
      <Modal
        open={showModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropComponent={Backdrop}
      >
        <Paper style={style} elevation={3}>
          <CForm className="needs-validation">
            {ModalTitle !== "" && (
              <CRow
                style={{
                  borderBottom: "1px solid #CCC",
                  margin: "-1rem -1rem 1rem -1rem",
                }}
              >
                <CCol>
                  <CLabel className={"ModelLabel"}>
                    {ModalTitle}
                    {/* Please Confrimation */}
                  </CLabel>
                </CCol>
              </CRow>
            )}
            <CRow>
              <CCol>
                <CLabel>{ModalBody}</CLabel>
              </CCol>
            </CRow>
            <CRow style={rowFooterStyle} className={rowFooterClassName}>
              <CCol xl={12} className={"d-flex justify-content-end"}>
                <CButton
                  className="mt-2"
                  color="success"
                  onClick={() => {
                    index > -1
                      ? !ButtonLoader && confirmModal(id, index)
                      : !ButtonLoader && confirmModal(id);
                  }}
                  disabled={ButtonLoader}
                >
                  {ButtonLoader && (
                    <>
                      <CSpinner as="span" size="sm" aria-hidden="true" />
                      &nbsp;
                    </>
                  )}
                  Yes
                </CButton>
                <CButton
                  className="mt-2 ml-3"
                  color="danger"
                  type="button"
                  onClick={!ButtonLoader && handleClose}
                  disabled={ButtonLoader}
                >
                  No
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </Paper>
      </Modal>{" "}
      {/* <CModal show={showModal} backdrop fade BackdropComponent={Backdrop}>
        <CModalHeader
          closeButton={false}
          //onClick={(e) => !ButtonLoader && handleClose(e)}
          disabled={ButtonLoader}
        >
          <CModalTitle>{ModalTitle}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div>{ModalBody}</div>
        </CModalBody>
        <CModalFooter>
          <CButton
            //variant={confirmButtonCss}
            color="success"
            onClick={() => {
              index > -1 ? confirmModal(id, index) : confirmModal(id);
            }}
          >
            {ButtonLoader && (
              <>
                <CSpinner as="span" size="sm" aria-hidden="true" />
                &nbsp;
              </>
            )}
            Yes
          </CButton>
          <CButton
            color="danger"
            onClick={(e) => !ButtonLoader && handleClose(e)}
            disabled={ButtonLoader}
          >
            No
          </CButton>
        </CModalFooter>
      </CModal>{" "} */}
      {/* <CModal centered={true} show={showModal} onClose={hideModal}>
        <CModalHeader closeButton>
          <CModalTitle>{ModalTitle}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div>{ModalBody}</div>
        </CModalBody>
        <CModalFooter>
          <CButton variant="default" onClick={hideModal}>
            {" "}
            Cancel{" "}
          </CButton>
          <CButton
            variant={confirmButtonCss}
            onClick={() => {
              index > -1 ? confirmModal(id, index) : confirmModal(id);
            }}
          >
            {ButtonLoader && (
              <>
                <CSpinner as="span" size="sm" aria-hidden="true" />
                &nbsp;
              </>
            )}
            {ConfirmButtonText}
          </CButton>
        </CModalFooter>
      </CModal> */}
    </div>
  );
};
export default ConfirmationPopup;
